const page = {
  header: {
    title: {
      ua: 'ZYN на тест',
      ru: 'ZYN на тест'
    },
    imageMob:
      'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/minidry/main.png',
    imageDesk:
      'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/minidry/main.png',
    backgroundMob:
      'linear-gradient(0deg, rgba(255, 253, 251, 1) 0%, rgba(47,184,228,1) 40%, rgba(0,169,224,1) 100%)',
    backgroundDesk:
      'linear-gradient(0deg, rgba(255, 253, 251, 1) 0%, rgba(102,202,234,1) 60%, rgba(0,169,224,1) 100%)',
    text: {
      ua:
        'Шукаєш заміну сигаретам чи одноразкам? Можеш спробувати паучі ZYN. Тут ні тютюну, ні диму, ні пари, ще й оновлений лук. Даємо баночку ZYN на тест безкоштовно.',
      ru:
        'Ищешь замену сигаретам или одноразкам? Можешь попробовать паучи ZYN. Здесь ни табака, ни дыма, ни пара еще, и обновленный лук. Даем баночку ZYN на тест бесплатно.'
    },
    button: {
      ua: 'Хочу спробувати',
      ru: 'Хочу спробувати'
    }
  },
  how: {
    title: {
      ua: 'Як це працює?',
      ru: 'Как это работает?'
    },
    item1: {
      ua: 'Залиш свій номер у формі нижче',
      ru: 'Оставляешь контакты'
    },
    item2: {
      ua: 'Ми наберемо впродовж дня',
      ru: 'Наберем в течение дня, чтобы запланировать доставку'
    },
    item3: {
      ua: 'Разом оберемо міцність, смак і заплануємо доставку',
      ru: 'Отправляем бесплатную банку ZYN'
    },
    item4: {
      ua: 'Відправимо тестову баночку безкоштовно, куди скажеш',
      ru: 'Тестируешь и делишься впечатлениями'
    }
  },
  block: {
    title: {
      ua: 'Чому ZYN?',
      ru: 'Почему ZYN?'
    },
    imgMob: {
      ua: 'https://d2esxfdt32vo54.cloudfront.net/images/ua/try-zyn/mob_1.png',
      ru: 'https://d2esxfdt32vo54.cloudfront.net/images/ua/try-zyn/mob_1.png'
    },
    imgDesk: {
      ua: 'https://d2esxfdt32vo54.cloudfront.net/images/ua/try-zyn/desk_1.png',
      ru: 'https://d2esxfdt32vo54.cloudfront.net/images/ua/try-zyn/desk_1.png'
    },
    list: [
      {
        text: {
          ua: 'Без тютюну та диму',
          ru: 'Без тютюну та диму'
        },
        icon:
          'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/minidry/1.svg'
      },
      {
        text: {
          ua: 'Можна юзати будь-де',
          ru: 'Можно юзать где угодно'
        },
        icon:
          'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/minidry/2.svg'
      },
      {
        text: {
          ua: 'Дуже прості у використанні',
          ru: 'Дуже прості у використанні'
        },
        icon:
          'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/minidry/3.svg'
      }
    ]
  },
  form: {
    title: {
      ua: 'Введи номер телефону',
      ru: 'Введи номер телефону'
    },
    text: {
      ua: 'Зателефонуємо протягом дня і відправимо ZYN на тест якнайшвидше.',
      ru: 'Зателефонуємо протягом дня і відправимо ZYN на тест якнайшвидше.'
    },
    label: {
      ua: 'Номер телефону',
      ru: 'Номер телефона'
    },
    button: {
      ua: 'Хочу ZYN',
      ru: 'Хочу ZYN'
    }
  },
  popup: {
    form: {
      title: {
        ua: 'Замовити набір ZYN',
        ru: 'Заказать набор ZYN'
      },
      text: {
        ua:
          'Залиш свій номер телефону і ми зателефонуємо, щоб уточнити деталі для безкоштовної доставки твого замовлення.',
        ru:
          'Оставь свой номер телефона и мы перезвоним, чтобы уточнить детали для бесплатной доставки твоего заказа.'
      },
      label: {
        ua: 'Номер телефону',
        ru: 'Номер телефона'
      },
      button: {
        ua: 'Чекаю на дзвінок',
        ru: 'Жду звонка'
      },
      error: {
        ua: 'Невірний номер. Перевір і спробуй ще раз, будь ласка',
        ru:
          'Неправильный номер телефона. Проверь и попробуй еще раз, пожалуйста'
      }
    },
    otp: {
      title: {
        ua: 'Підтвердити номер',
        ru: 'Подтвердить номер'
      },
      text: {
        ua:
          'Введи код, що прийшов у смс. Не отримав? Можемо зателефонувати і сказати код через ',
        ru:
          'Введи код, що прийшов у смс. Не отримав? Можемо зателефонувати і сказати код через '
      },
      time: {
        ua: ' сек.',
        ru: ' сек.'
      },
      calling_text: {
        ua:
          'Телефонуємо тобі, щоб назвати код. Немає дзвінку? Тоді спробуй, будь ласка, пізніше.',
        ru:
          'Телефонуємо тобі, щоб назвати код. Немає дзвінку? Тоді спробуй, будь ласка, пізніше.'
      },
      legal_text: {
        ua: 'Вводячи цей код, я погоджуюся з ',
        ru: 'Вводя этот код, я соглашаюсь с '
      },
      legal_link_text: {
        ua: 'Політикою конфіденційності',
        ru: 'Политикой конфиденциальности '
      },
      legal_link: {
        ua: '/privacy-policy',
        ru: '/privacy-policy'
      },
      subscription: {
        ua: 'Тримайте мене в курсі сервісів і пропозицій',
        ru: 'Держите меня в курсе сервисов и предложений'
      },
      otp_error: {
        ua: 'Невірний код. Перевір і спробуй ще раз, будь ласка.',
        ru: 'Неправильный код. Проверь и попробуй еще раз, пожалуйста. '
      },
      callme: {
        ua: 'Зателефонуйте мені',
        ru: 'Позвоните мне'
      },
      button: {
        ua: 'Підтвердити',
        ru: 'Подтвердить'
      }
    },
    ok: {
      title: {
        ua: 'Заявочка в роботі!',
        ru: 'Заявочка в работе!'
      },
      text: {
        ua:
          'Наберемо якнайшвидше, щоб відправити тобі безкоштовну банку ZYN на тест.',
        ru:
          'Наберем как можно быстрее отправить тебе бесплатную банку ZYN на тест.'
      },
      button: {
        ua: 'Прийнято',
        ru: 'Принято'
      }
    },
    error: {
      title: {
        ua: 'Щось пішло не за планом',
        ru: 'Что-то пошло не по плану'
      },
      text: {
        ua:
          'Може бути таке, що ти вже брав безкоштовну банку ZYN на тест? Якщо ні, набери нас на 9960.',
        ru:
          'Может быть, ты уже брал бесплатную банку ZYN на тест? Если нет, набери нас на 9960.'
      },
      button: {
        ua: 'Ну ладно',
        ru: 'Ну ладно'
      }
    },
    duplicate: {
      title: {
        ua: 'Почекай ще трошки',
        ru: 'Подожди еще немного'
      },
      text: {
        ua:
          "Так-так, пам'ятаємо, що ти замовив ZYN на тест. Щойно ZYN з'явиться, наберемо тебе, щоб запланувати доставку.",
        ru:
          'Да-да, помним, что ты заказал ZYN на тест. Как только ZYN появится, наберем тебя, чтобы запланировать доставку.'
      },
      button: {
        ua: 'Прийнято',
        ru: 'Принято'
      }
    }
  },
  productsCarousel: {
    title: {
      ua: 'Усі смаки ZYN',
      ru: 'Все вкусы ZYN'
    },
    text: {
      ua:
        'Не стоп, а пауза, щоб зробити вибір. Бо є з чого! Свіжі, насичені ментолові, фруктові та ягідні нікотинові подушечки ZYN',
      ru:
        'Не стоп, а пауза, щоб зробити вибір. Бо є з чого! Свіжі, насичені ментолові, фруктові та ягідні нікотинові подушечки ZYN'
    },
    btn: {
      ua: 'Дивитись всі смаки',
      ru: 'Дивитись всі смаки'
    },
    products: [
      {
        name: {
          ua: 'ZYN<br/> Cool Mint',
          ru: 'ZYN<br/> Cool Mint'
        },
        taste: {
          ua: 'М’ята та ментол',
          ru: 'Мята и ментол'
        },
        tars: '1,5 мг|3 мг|6 мг|9 мг|11 мг',
        img: {
          ua:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/cool_mint.png',
          ru:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/cool_mint.png'
        }
      },
      {
        name: {
          ua: 'ZYN<br/> Black Cherry',
          ru: 'ZYN<br/> Black Cherry'
        },
        taste: {
          ua: 'Солодка черешня',
          ru: 'Солодка черешня'
        },
        tars: '1,5 мг|3 мг|6 мг|11 мг',
        img: {
          ua:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/black_cherry.png',
          ru:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/black_cherry.png'
        }
      },
      {
        name: {
          ua: 'ZYN<br/> Spearmint',
          ru: 'ZYN<br/> Spearmint'
        },
        taste: {
          ua: `Солодка м'ята`,
          ru: `Солодка м'ята`
        },
        tars: '1,5 мг|3 мг|6 мг|11 мг',
        img: {
          ua:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/spearmint.png',
          ru:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/spearmint.png'
        }
      },
      {
        name: {
          ua: 'ZYN<br/> Blackcurrant Frost',
          ru: 'ZYN<br/> Blackcurrant Frost'
        },
        taste: {
          ua: 'Чорна смородина та ментол',
          ru: 'Черная смородина и ментол'
        },
        tars: '11 мг',
        img: {
          ua:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/balckcurrant_frost.png',
          ru:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/blackcurrant_frost.png'
        }
      },
      {
        name: {
          ua: 'ZYN<br/> Black Menthol',
          ru: 'ZYN<br/> Black Menthol'
        },
        taste: {
          ua: 'Ментол на максимум',
          ru: 'Ментол на максимум'
        },
        tars: '11 мг|16,5 мг',
        img: {
          ua:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/black_menthol_11.png',
          ru:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/black_menthol_11.png'
        }
      },
      {
        name: {
          ua: 'ZYN<br/> Blueberry Mint',
          ru: 'ZYN<br/> Blueberry Mint'
        },
        taste: {
          ua: 'Лохина і м`ята',
          ru: 'Голубика и мята'
        },
        tars: '11 мг',
        img: {
          ua:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/blueberry_mint.png',
          ru:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/blueberry_mint.png'
        }
      },
      {
        name: {
          ua: 'ZYN<br/> Menthol Ice',
          ru: 'ZYN<br/> Menthol Ice'
        },
        taste: {
          ua: 'Евкаліпт та ментол',
          ru: 'Евкаліпт та ментол'
        },
        tars: '11 мг|13,5 мг|16,5 мг',
        img: {
          ua:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/menthol_ice.png',
          ru:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/menthol_ice.png'
        }
      },
      {
        name: {
          ua: 'ZYN<br/> Black Cherry Frost',
          ru: 'ZYN<br/> Black Cherry Frost'
        },
        taste: {
          ua: 'Морозна черешня',
          ru: 'Морозная черешня'
        },
        tars: '13,5 мг|16,5 мг',
        img: {
          ua:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/black_cherry_frost_13.5.jpg',
          ru:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/black_cherry_frost_13.5.jpg'
        }
      },
      {
        name: {
          ua: 'ZYN<br/> Cool Mint Ice',
          ru: 'ZYN<br/> Cool Mint Ice'
        },
        taste: {
          ua: 'М’ята та ментол',
          ru: 'Мята и ментол'
        },
        tars: '13,5 мг|16,5 мг',
        img: {
          ua:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/cool_mint_ice.png',
          ru:
            'https://d2esxfdt32vo54.cloudfront.net/images/ua/smpl/carousel/cool_mint_ice.png'
        }
      }
    ]
  }
};

export { page };
